<script lang="ts">
  import { Createdbyme, Print, href } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import FeatherIcons from "svelte-feather-icon";
  import {tasksTabId} from "../../../store"
  import CreatedByMeBody from "./CreatedByMeBody.svelte";
  import Link from "svelte-link";
  let setTasksTab:string
  tasksTabId.subscribe((value)=>{
    setTasksTab = value
  })
</script>
<div class="tab-pane fade {setTasksTab == "pills-created" ? "active show" : ""}" id="pills-created" role="tabpanel">
  <Card cardProps="mb-0" cardBodyprops="p-0">
    <div slot="customheader" class="d-flex align-items-center justify-content-between w-100">
      <h5 class="mb-0">{Createdbyme}</h5>
      <Link class="f-w-600 d-flex align-items-center gap-2" href={href}>
          <FeatherIcons class="me-2" icon="printer" />{Print}
      </Link>
    </div>
    <div slot="contentbody">
      <CreatedByMeBody />
    </div>
  </Card>
</div>